module.exports = {
	"Заполните название вашей компании": "Enter your company name",
	"Заполните ваше имя и фамилию": "Enter your name and surname",
	"Телефон должен начинаться с \"+\" и кода страны": "Phone number should start with ”+“ and the country code",
	"Телефон должен быть в международном формате и содержать 12 цифр": "Use international phone number",
	"Неправильный имейл": "Wrong email",
	"Пароль должен сожержать не меньше 8 символов": "Password should contain at least 8 symbols",
	"Текст об интеграции должен быть не меньше двух предложений (100 символов)": "Write at least 2 sentences (100 characters) about your integration",
	"Неправильный номер телефона. Попробуйте ввести номер в международном формате.": "Wrong phone number. Try to enter the phone in the international format."
};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en/site.json
// module id = 266
// module chunks = 1